var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CardForm", {
        staticClass: "mb-2 flex justify-end",
        attrs: {
          value: _vm.finalHours,
          subject: `${_vm.finalHoursText}*`,
          buttonText: _vm.finalHoursText,
          subjectClasses: "min-w-44",
        },
        on: {
          update: (hours) =>
            _vm.confirmUpdate({
              optionName: _vm.finalHoursText,
              controversialOptionName: _vm.finalCostText,
              controversialOptionValue: _vm.finalCost,
              action: () => _vm.updateFinalHours(hours),
            }),
        },
      }),
      _c("CardForm", {
        staticClass: "mb-1 flex justify-end",
        attrs: {
          value: _vm.finalCost,
          shownValue: _vm.finalCostContent,
          subject: "Final Task Cost*",
          subjectAddition: "(approx)",
          subjectClasses: "min-w-44",
          description:
            "This is an estimate only. All costs are before tax and not based on currency.",
          "input-prefix": "$",
          buttonText: _vm.finalCostText,
        },
        on: {
          update: (cost) =>
            _vm.confirmUpdate({
              optionName: _vm.finalCostText,
              controversialOptionName: _vm.finalHoursText,
              controversialOptionValue: _vm.finalHours,
              action: () => _vm.updateFinalCost(cost),
            }),
        },
      }),
      _c("p", { staticClass: "text-label" }, [
        _vm._v("* - only one field can be filled"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }